import { Component, HostListener, OnInit, ViewChild, inject } from '@angular/core'
import { ConfirmationService, ConfirmEventType } from 'primeng/api'
import { ConfirmDialog as confirmDialogPrimeNG } from 'primeng/confirmdialog'
import { ConfirmDialogService } from 'src/app/data/services/components/confirm-dialog/confirm-dialog.service'
import { ButtonColor, ButtonVariant } from 'src/app/domain/enums/components/button.enum'
import { PrimeIcon } from 'src/app/domain/enums/components/prime-icons.enum'
import { ConfirmDialog } from 'src/app/domain/interfaces/components/confirm-dialog.interface'
import { MODAL_TRANSITION_OPTIONS } from '../../animations/motion.tokens'

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  providers: [ConfirmationService]
})
export class ConfirmDialogComponent implements OnInit {
  private confirmationService: ConfirmationService = inject(ConfirmationService)
  private confirmDialogService: ConfirmDialogService = inject(ConfirmDialogService)

  @ViewChild('confirmDialog') confirmDialog: confirmDialogPrimeNG | any

  private activeConfirm: ConfirmDialog | null = null

  callbackAccept: Function = () => {
    this.activeConfirm = null
    this.confirmDialog.accept()
  }

  callbackReject: Function = () => {
    const rejectedCallback = this.activeConfirm?.rejectedCallback
    this.activeConfirm = null
    this.confirmDialog.reject()
    if (rejectedCallback) setTimeout(() => rejectedCallback(), 150)
  }

  acceptLabel: string = 'Confirmar'
  rejectLabel: string = 'Cancelar'

  buttonVariant = ButtonVariant
  buttonColor = ButtonColor
  primeIcon = PrimeIcon
  transitionOptions: string = MODAL_TRANSITION_OPTIONS

  public ngOnInit(): void {
    this.confirmDialogService.confirmSubject.subscribe((confirmDialog: ConfirmDialog) => {
      this.showConfirm(confirmDialog)
    })
  }

  public showConfirm(confirmDialogConfig: ConfirmDialog): void {
    this.activeConfirm = confirmDialogConfig
    this.acceptLabel = confirmDialogConfig.acceptLabel ?? 'Confirmar'
    this.rejectLabel = confirmDialogConfig.rejectLabel ?? 'Cancelar'
    this.confirmationService.confirm({
      message: confirmDialogConfig.message,
      accept: () => {
        confirmDialogConfig.acceptedCallback()
      },
      reject: (type?: ConfirmEventType) => {
        if (type === ConfirmEventType.CANCEL) this.activeConfirm = null
      },
      acceptLabel: this.acceptLabel,
      rejectLabel: this.rejectLabel
    })

    this.resetWindowFocus()
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (this.confirmDialog) this.confirmDialog.accept()
  }

  private resetWindowFocus() {
    if (document.activeElement) {
      ;(document.activeElement as HTMLElement).blur()
    }

    window.focus()
  }
}
